import React from "react";
import {PasswordField} from "../../../Components/Inputs";

interface UserDetailsPasswordFieldsProps {
    enablePasswordFields: boolean;
    userDetailsForm: Record<string, any>;
}

export const UserDetailsPasswordFields: React.FC<UserDetailsPasswordFieldsProps> = ({
                         enablePasswordFields,
                         userDetailsForm,
                     }) => {
    return         <>
        <PasswordField
            {...userDetailsForm.password}
            disabled={!enablePasswordFields}
        />
        <PasswordField
            {...userDetailsForm.confirmPassword}
            disabled={!enablePasswordFields}
            helpText={`<p>Password must be 6 characters or longer, have at least one capital letter, one number, and one non-alphanumeric character.</p>`}
        />
    </>
}
